import React, { useContext, useEffect, useState } from 'react'
import { ProjectSkeleton, ProjectSlider } from '../components/Projects';
import { ProjectCardDataInterface, ProjectCardResponseInterface } from '../interfaces/ProjectCardDataInterface';
import { getProjectCards } from '../../../services/projectService';
import { ProjectsContext } from '../../../contexts/ProjectsContext';

export const Projects = () => {
    const context = useContext(ProjectsContext);
    const { setProjectCards } = context;
    const [localProjectCards, setLocalProjectCards] = useState<ProjectCardDataInterface[]>([]);
    const [loading, setLoading] = useState(false)
    const [flag, setFlag] = useState(true)

    useEffect(() => {
        if (flag) {
            setLoading(true)
            getProjectCards()
                .then((resp: ProjectCardResponseInterface) => {
                    setLocalProjectCards(resp.data)
                    const filteredProjects = resp.data.filter((project) => project.phase !== 'Etapa 0');
                    setProjectCards(filteredProjects)
                })
                .finally(() => setLoading(false))
            setFlag(false)
        }
    }, [flag, setProjectCards])

    return (
        <>
            {
                loading ?
                    <ProjectSkeleton /> :
                    <ProjectSlider projectCards={localProjectCards} />
            }
        </>
    )
}
